module.exports = __webpack_public_path__ + "static/media/feature-3.e488fc4f.jpg";